module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "waiting-room-box column",
    staticStyle: {
      "height": "80vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "waiting-room-header column"
  }, [_c('div', {
    staticClass: "title-box row"
  }, [_c('i', {
    staticClass: "el-icon-arrow-left",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.toMy
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("過去に参加した結果")])])]), _vm._v(" "), _c('div', {
    staticClass: "waiting-room-info-box column"
  }, _vm._l((_vm.lists), function(item, index) {
    return (item.peopleNumber > 0 && item.status == 3) ? _c('div', {
      staticClass: "item row m-column"
    }, [_c('div', {
      staticClass: "title-box column"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.roomName))]), _vm._v(" "), _c('div', {
      staticClass: "label row m-column",
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_c('div', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('span', {
      staticClass: "iconfont icon-shijian"
    }), _vm._v(_vm._s(item.startTime))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "iconfont icon-01"
    }), _vm._v(_vm._s(item.homeownerName))]), _vm._v(" "), _c('div', [_c('i', {
      staticClass: "el-icon-collection-tag iconfont"
    }), _vm._v(_vm._s(item.theme))])])]), _vm._v(" "), _c('div', {
      staticClass: "btns-box row row-right"
    }, [_c('el-button', {
      staticClass: "details-btn",
      on: {
        "click": function($event) {
          return _vm.toRoom(item.id)
        }
      }
    }, [_vm._v("結果詳細")])], 1)]) : _vm._e()
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-154c330e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/room/Logs.vue
// module id = 882
// module chunks = 1